
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  changeEmailFormButton: {
    id: "ChangeEmailForm.button",
    defaultMessage: "Update Email Address",
  },
});

export default MESSAGES;